import { useMutation } from "@tanstack/react-query";

import type { IBulkShareSegmentsParams, IBulkShareSegmentsResponse } from "app/services/segments/segmentsApiService";
import SegmentsApiService from "app/services/segments/segmentsApiService";

interface UseBulkShareSegmentsOptions {
    onSuccess?: (data: IBulkShareSegmentsResponse) => void;
    onError?: (error: Error) => void;
}

export const useBulkShareSegments = (options?: UseBulkShareSegmentsOptions) => {
    return useMutation({
        mutationFn: (params: IBulkShareSegmentsParams) =>
            SegmentsApiService.getInstance().shareSegmentsBatch(params),
        onSuccess: options?.onSuccess,
        onError: options?.onError,
    });
};
